export default import.meta.ROLLUP_FILE_URL_nRQ3YEkAaAj$ixl_owQJ5A